import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { ScienceOutlined, SchoolOutlined, WorkOutlineOutlined, PeopleOutlineOutlined } from '@mui/icons-material';

const features = [
    {
        icon: <ScienceOutlined fontSize="large" color="primary" />,
        title: 'Practical Lab Sessions',
        description: 'Gain hands-on experience in real cloud environments with access to diverse lab exercises.',
    },
    {
        icon: <SchoolOutlined fontSize="large" color="primary" />,
        title: 'Hybrid Live Classes',
        description: 'Participate in live classes conducted by experienced experts, either in-person or virtually.',
    },
    {
        icon: <WorkOutlineOutlined fontSize="large" color="primary" />,
        title: 'Project-Based Learning',
        description: 'Work on real-world scenarios and projects to develop practical skills that are directly applicable.',
    },
    {
        icon: <PeopleOutlineOutlined fontSize="large" color="primary" />,
        title: 'Peer Collaboration',
        description: 'Engage in discussions, share your experiences, and learn from the diverse perspectives of your peers.',
    },
];

function HandsOnFeatures() {
    return (
        <Box sx={{ background: '#1f1f1f', pt: 4, pb: 4 }}>
            <Container>
                <Grid container spacing={4}>
                    {features.map((feature, index) => (
                        <Grid item sm={6} xs={12} key={index}>
                            <Box sx={{ textAlign: 'left' }}>
                                {feature.icon}
                                <Typography variant="h5" sx={{ color: '#fff', mt: 2 }}>
                                    {feature.title}
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#e0e0e0', mt: 1 }}>
                                    {feature.description}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}

export default HandsOnFeatures;
